var map = {
	"./illustrations-API.svg": "b7b8",
	"./illustrations-SDK.svg": "1d18",
	"./illustrations-discount-alternative.svg": "1d42",
	"./illustrations-discount.svg": "5eb8",
	"./illustrations-empty_data.svg": "0450",
	"./illustrations-error.svg": "0cec",
	"./illustrations-fail.svg": "9bfe",
	"./illustrations-money.svg": "0374",
	"./illustrations-rocket.svg": "987e",
	"./illustrations-sold-out.svg": "f2f1",
	"./illustrations-spreadsheet.svg": "43f8",
	"./illustrations-store.svg": "a26c",
	"./illustrations-storebatch.svg": "8c79",
	"./illustrations-success.svg": "e3dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1012";